import { get, some } from "lodash";

export const CDS_UPSELL_WEIGHT = 2;

export const subscriptionIncludesCds = (subscription) =>
  some(
    get(
      subscription,
      `project.fields.upsells.${get(subscription, "insurancePlan.id")}`,
      [],
    ),
    { weight: CDS_UPSELL_WEIGHT },
  );
